module.exports = __webpack_public_path__ + "img/yuanwei2.4e2c3761.gif";